export default function getValueFromQueryString(
  queryString: string | null,
  {
    min,
    max,
    step,
    defaultValue,
  }: { min: number; max: number; step: number; defaultValue: number },
) {
  if (!queryString) {
    return defaultValue;
  }

  const parsedValue = parseInt(queryString, 10);

  if (Number.isNaN(parsedValue)) {
    return defaultValue;
  }

  if (parsedValue > max) {
    return max;
  }

  if (parsedValue < min) {
    return min;
  }

  if (parsedValue % step !== 0) {
    return Math.min(Math.ceil(parsedValue / step) * step, max);
  }

  return parsedValue;
}
